import React from "react";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";

import { Grid } from "@material-ui/core";
import {
  FlexGridItem,
  FlexTextField,
  required,
  validEmail,
} from "./form_utility";
import { Loader } from "../common/loader.component";
import { Toaster } from "../common/toaster.component";
import { openToaster, closeToaster } from "src/actions/common";
import { actionSaveSPUser } from "src/actions/detail";

import { CustomButton } from "src/styles/general";

class SpFormComponent extends React.Component<any, any> {
  render() {
    const {
      handleSubmit,
      toasterMessage,
      isToasterVisible,
      showLoader,
      isSuccessMessage,
      closeToaster,
    } = this.props;
    return (
      <React.Fragment>
        <div>
          <Loader visible={showLoader} />
          <Toaster
            message={toasterMessage}
            open={isToasterVisible}
            close={closeToaster}
            success={isSuccessMessage}
          />
          <h1>Add Solution Provider User here</h1>
          <form>
            <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
              <FlexGridItem xs={4}>
                <FlexTextField
                  name="firstName"
                  label="First Name"
                  required={true}
                  validate={[required]}
                />
              </FlexGridItem>
              <FlexGridItem xs={4}>
                <FlexTextField
                  name="lastName"
                  label="Last Name"
                  required={true}
                  validate={[required]}
                />
              </FlexGridItem>
              <FlexGridItem xs={4}>
                <FlexTextField
                  name="email"
                  label="Email Id"
                  required={true}
                  validate={[required, validEmail]}
                />
              </FlexGridItem>
            </Grid>
          </form>
          <Grid style={{ paddingTop: "25px" }} container={true} spacing={2}>
            <Grid item>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={handleSubmit(this.submitForm)}
              >
                SAVE
              </CustomButton>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }

  private submitForm = (values: any) => {
    const { saveSPUser } = this.props;
    saveSPUser(values);
  };
}

const MyReduxForm = reduxForm<any, any>({
  enableReinitialize: true,
  form: "solutionProviderForm",
  keepDirtyOnReinitialize: true,
})(SpFormComponent);

const mapStateToProps = (state: any, ownProps: any) => ({
  isLoaderVisible: state.common.isLoaderVisible,
  toasterMessage: state.common.toasterMessage,
  isToasterVisible: state.common.isToasterVisible,
  isSuccessMessage: state.common.isSuccess,
});
const mapDispatchToProps = (dispatch: any) => {
  return {
    saveSPUser: (formData: any) => dispatch(actionSaveSPUser(formData)),
    openToaster: (message: string, success: boolean) =>
      dispatch(openToaster(message, success)),
    closeToaster: () => dispatch(closeToaster()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MyReduxForm);
